import {
  ISTOtherPublication,
  ISTPersonActivity,
  IUnit as IAaNgUnit,
  PersonProfile as AaNgPersonProfile,
} from 'aa-ng';

import {
  DesiredExposure,
  IEditableTerm,
  IInstitution,
  IPerson,
  IUnit,
} from '.';

export class PersonProfile implements IPerson {
  id: number;
  guid?: string;
  aaId?: number;
  firstName: string;
  lastName: string;
  middleName: string;
  primaryUnitAffiliation?: IUnit;
  nonPrimaryUnitAffiliations?: IUnit[];
  primaryInstitution: IInstitution;
  desiredExposure: DesiredExposure;
  isNonFaculty: boolean;
  degreeYear?: number;
  hasPreferredName?: boolean;
  isMatchVerificationComplete?: boolean;
  title?: string;

  articles: ISTPersonActivity[];
  awards: ISTPersonActivity[];
  books: ISTPersonActivity[];
  bookChapters: ISTPersonActivity[];
  classroomEducationalMaterials: ISTPersonActivity[];
  clinicalTrials: ISTPersonActivity[];
  conferenceProceedings: ISTPersonActivity[];
  courses: ISTPersonActivity[];
  exhibits: ISTPersonActivity[];
  grants: ISTPersonActivity[];
  literaryWorks: ISTPersonActivity[];
  onlineEducationalMaterials: ISTPersonActivity[];
  otherContent: ISTPersonActivity[];
  otherCreativeWorks: ISTPersonActivity[];
  patents: ISTPersonActivity[];
  performances: ISTPersonActivity[];
  presentations: ISTPersonActivity[];
  productions: ISTPersonActivity[];
  researchDataSets: ISTPersonActivity[];
  reviewers: ISTPersonActivity[];
  softwareDigitalMedia: ISTPersonActivity[];
  communityEngagements: ISTPersonActivity[];
  technologies: ISTPersonActivity[];
  fieldResearch: ISTPersonActivity[];
  projects: ISTPersonActivity[];
  media: ISTPersonActivity[];
  memberships: ISTPersonActivity[];
  otherIntellectualProperty: ISTPersonActivity[];
  educationalMaterials: ISTPersonActivity[];
  otherPublications: ISTOtherPublication[];
  unitAffiliations: IUnit[];
  researchSummary: string;
  researchInterests: IEditableTerm[];

  get activities(): ISTPersonActivity[] {
    return ([] as ISTPersonActivity[])
      .concat(this.articles)
      .concat(this.awards)
      .concat(this.books)
      .concat(this.bookChapters)
      .concat(this.clinicalTrials)
      .concat(this.classroomEducationalMaterials)
      .concat(this.conferenceProceedings)
      .concat(this.exhibits)
      .concat(this.grants)
      .concat(this.literaryWorks)
      .concat(this.onlineEducationalMaterials)
      .concat(this.otherContent)
      .concat(this.otherCreativeWorks)
      .concat(this.patents)
      .concat(this.performances)
      .concat(this.presentations)
      .concat(this.productions)
      .concat(this.researchDataSets)
      .concat(this.softwareDigitalMedia)
      .concat(this.reviewers)
      .concat(this.communityEngagements)
      .concat(this.technologies)
      .concat(this.fieldResearch)
      .concat(this.projects)
      .concat(this.media)
      .concat(this.memberships)
      .concat(this.otherIntellectualProperty)
      .concat(this.educationalMaterials)
      .concat(this.otherPublications);
  }
}

export function mapPersonProfile(
  personProfile: PersonProfile,
): AaNgPersonProfile {
  const {
    id,
    guid,
    firstName,
    lastName,
    middleName,
    primaryInstitution,
    primaryUnitAffiliation,
    nonPrimaryUnitAffiliations,
    isNonFaculty,
    desiredExposure,
    degreeYear,
    articles,
    awards,
    books,
    bookChapters,
    classroomEducationalMaterials,
    clinicalTrials,
    conferenceProceedings,
    courses,
    exhibits,
    grants,
    literaryWorks,
    onlineEducationalMaterials,
    otherContent,
    otherCreativeWorks,
    patents,
    performances,
    presentations,
    productions,
    researchDataSets,
    reviewers,
    softwareDigitalMedia,
    communityEngagements,
    technologies,
    fieldResearch,
    projects,
    media,
    memberships,
    otherIntellectualProperty,
    educationalMaterials,
    unitAffiliations,
    researchInterests,
    researchSummary,
    title,
    otherPublications,
  } = personProfile;

  const aaNgPersonProfile = new AaNgPersonProfile();
  aaNgPersonProfile.id = id;
  aaNgPersonProfile.guid = guid;
  aaNgPersonProfile.firstName = firstName;
  aaNgPersonProfile.lastName = lastName;
  aaNgPersonProfile.middleName = middleName;
  aaNgPersonProfile.primaryInstitution = primaryInstitution;
  aaNgPersonProfile.primaryUnitAffiliation = primaryUnitAffiliation;
  aaNgPersonProfile.nonPrimaryUnitAffiliations = nonPrimaryUnitAffiliations;
  aaNgPersonProfile.isNonFaculty = isNonFaculty;
  aaNgPersonProfile.desiredExposure = desiredExposure;
  aaNgPersonProfile.degreeYear = degreeYear;
  aaNgPersonProfile.articles = articles && articles.length ? articles : [];
  aaNgPersonProfile.awards = awards && awards.length ? awards : [];
  aaNgPersonProfile.books = books && books.length ? books : [];
  aaNgPersonProfile.bookChapters =
    bookChapters && bookChapters.length ? bookChapters : [];
  aaNgPersonProfile.classroomEducationalMaterials =
    classroomEducationalMaterials && classroomEducationalMaterials.length ?
      classroomEducationalMaterials
    : [];
  aaNgPersonProfile.clinicalTrials =
    clinicalTrials && clinicalTrials.length ? clinicalTrials : [];
  aaNgPersonProfile.conferenceProceedings =
    conferenceProceedings && conferenceProceedings.length ?
      conferenceProceedings
    : [];
  aaNgPersonProfile.courses = courses;
  aaNgPersonProfile.exhibits = exhibits && exhibits.length ? exhibits : [];
  aaNgPersonProfile.grants = grants && grants.length ? grants : [];
  aaNgPersonProfile.literaryWorks =
    literaryWorks && literaryWorks.length ? literaryWorks : [];
  aaNgPersonProfile.onlineEducationalMaterials =
    onlineEducationalMaterials && onlineEducationalMaterials.length ?
      onlineEducationalMaterials
    : [];
  aaNgPersonProfile.otherContent =
    otherContent && otherContent.length ? otherContent : [];
  aaNgPersonProfile.otherCreativeWorks =
    otherCreativeWorks && otherCreativeWorks.length ? otherCreativeWorks : [];
  aaNgPersonProfile.patents = patents && patents.length ? patents : [];
  aaNgPersonProfile.performances =
    performances && performances.length ? performances : [];
  aaNgPersonProfile.presentations =
    presentations && presentations.length ? presentations : [];
  aaNgPersonProfile.productions =
    productions && productions.length ? productions : [];
  aaNgPersonProfile.researchDataSets =
    researchDataSets && researchDataSets.length ? researchDataSets : [];
  aaNgPersonProfile.reviewers = reviewers && reviewers.length ? reviewers : [];
  aaNgPersonProfile.softwareDigitalMedia =
    softwareDigitalMedia && softwareDigitalMedia.length ?
      softwareDigitalMedia
    : [];
  aaNgPersonProfile.communityEngagements =
    communityEngagements && communityEngagements.length ?
      communityEngagements
    : [];
  aaNgPersonProfile.technologies =
    technologies && technologies.length ? technologies : [];
  aaNgPersonProfile.fieldResearch =
    fieldResearch && fieldResearch.length ? fieldResearch : [];
  aaNgPersonProfile.projects = projects && projects.length ? projects : [];
  aaNgPersonProfile.media = media && media.length ? media : [];
  aaNgPersonProfile.memberships =
    memberships && memberships.length ? memberships : [];
  aaNgPersonProfile.otherIntellectualProperty =
    otherIntellectualProperty && otherIntellectualProperty.length ?
      otherIntellectualProperty
    : [];
  aaNgPersonProfile.educationalMaterials =
    educationalMaterials && educationalMaterials.length ?
      educationalMaterials
    : [];
  aaNgPersonProfile.unitAffiliations =
    unitAffiliations ? (unitAffiliations as IAaNgUnit[]) : [];
  aaNgPersonProfile.researchInterests = researchInterests;
  aaNgPersonProfile.researchSummary = researchSummary;
  aaNgPersonProfile.title = title;
  aaNgPersonProfile.otherPublications =
    otherPublications && otherPublications.length ? otherPublications : [];
  return aaNgPersonProfile;
}
